import { replaceMessage } from 'uiComponents/messages/actions'
import { Parkmap } from '../models'
import { useUpdateParkMapMutation } from '../reduxQuery'
import { useSelectedParkMapContext } from '../context/selectedParkMap'
import { useAppDispatch } from 'store/hooks'
import { useTranslation } from 'translations'

export const useUpdateMap = () => {
    const { t } = useTranslation()
    const [updateParkMap, { isLoading }] = useUpdateParkMapMutation()
    const { selectedParkMap, setSelectedParkMap } = useSelectedParkMapContext()
    const dispatch = useAppDispatch()

    const updateMapStylingData = () => {
        if (!selectedParkMap) {
            return
        }
        updateMap(selectedParkMap)
    }

    const updateMap = (parkmap: Parkmap) => {
        updateParkMap({ parkMap: parkmap })
            .unwrap()
            .then((response) => {
                if (response) {
                    setSelectedParkMap(response)
                }
                dispatch(replaceMessage('update_park_map', 'success', t('venue.parkMap.messages.mapUpdated'), 5000))
            })
            .catch((error) => {
                dispatch(replaceMessage('update_park_map', 'error', t('venue.parkMap.messages.genericError'), 5000))
            })
    }

    return { isLoading, updateMap, updateMapStylingData }
}

export default useUpdateMap
